/**
 * The chrome of the inner screens: a header with a way back.
 *
 * The bottom bar that used to live here is gone (NAVIGATION.md §1) — navigation
 * moved inside the Orb. SECTIONS stays, because the orbit menu and Home's
 * circles both read from it: one list, one order, one place to change it.
 */

import { miniOrb } from './orb.js'
import { text } from '../js/html.js'

/** The five destinations, in order. Home first, because back always means up. */
export const SECTIONS = [
  { key: 'home', path: '/', label: 'Home', icon: 'labHome' },
  { key: 'path', path: '/path', label: 'Path', icon: 'labPath' },
  { key: 'gallery', path: '/galerija', label: 'Gallery', icon: 'labGallery' },
  { key: 'group', path: '/grupa', label: 'Group', icon: 'labGroup' },
  { key: 'you', path: '/ti', label: 'You', icon: 'labYou' },
]

/**
 * The top of every screen — Home included (NAVIGATION.md §2, equalised at
 * Željko's request).
 *
 * One shape everywhere: a label on the left, the orb in the right-hand corner,
 * and nothing else. The orb is the menu, so it is always in the same place for
 * the same thumb; it carries an LED on its rim when some section has something
 * unseen, the same lamp from the same fact.
 *
 * There was an avatar beside it for a while. It said nothing the person did not
 * already know — whose phone this is — and it sat where the one control on the
 * screen needed the room.
 *
 * `bare` is Home: no rule, no surface behind it, and the wordmark in place of a
 * screen name, because Home is not somewhere you navigated to.
 *
 * `back` is for sub-pages only (a brief, a questionnaire). A section screen gets
 * none: back from there is Home, and the orb is how you get anywhere. When it is
 * there it carries a word, never a bare chevron.
 */
export function renderHeader({ title, back = null, alert = false, bare = false }) {
  return `
    <header class="hdr ${bare ? 'hdr--bare' : ''}">
      ${
        back === null
          ? ''
          : `<a class="hdr__back" href="${text(back.to)}" data-link>
               <b>\u2039 ${text((back.label ?? 'Home').toUpperCase())}</b>
             </a>`
      }
      <span class="hdr__name">${bare ? 'DIFFER LX' : text((title ?? '').toUpperCase())}</span>
      <button type="button" class="hdr__orb" data-orbit-open
              aria-label="Navigation menu" aria-expanded="false">
        ${miniOrb()}
        ${alert ? '<span class="hdr__led" aria-hidden="true"></span>' : ''}
      </button>
    </header>
  `
}
